import pay from './pay'
import upload from './upload'
import address from './address'
import delivery from './delivery'
import recipient from './recipient'

export default {
  namespaced: true,
  modules: {
    pay,
    upload,
    address,
    delivery,
    recipient
  },
  actions: {
    resetLetter({ commit }) {
      commit('pay/RESET_STATE_ALL')
      commit('upload/RESET_STATE_ALL')
      commit('address/RESET_STATE_ALL')
      commit('delivery/RESET_STATE_ALL')
      commit('recipient/RESET_STATE_ALL')
    }
  }
}
